import { Box, Typography, Grid, Checkbox } from '@mui/material'
import React from 'react'
import { mainHeading, subHeading } from '../../styles/style'
import { ArrowForwardIos } from '@mui/icons-material'
import FormControlLabel from '@mui/material/FormControlLabel';

export default function ContactForm() {
  return (
    <>
        <Box className="pplacd-container" >
        <Grid container >
          <Grid item md={12} spacing={2} >
           <Box sx={{textAlign:'center', my:5}}>
            <Typography sx={subHeading}>Contact Us</Typography>
            <Typography sx={mainHeading}>Get in Touch</Typography>
            </Box>
             <form>
             <Grid container spacing={5}>
          <Grid item md={6}  >
          <Typography component="label" sx={{ fontWeight: 600, fontFamily: 'Inter', fontSize:14 }}>Name</Typography>
           <input type="text" placeholder="Enter Your Name" className='inputBox' />            
            </Grid>
          <Grid item md={6} >
          <Typography component="label" sx={{ fontWeight: 600, fontFamily: 'Inter', fontSize:14 }}>Company (Optional)</Typography>
           <input type="text" placeholder="Enter Your Company (Optional)" className='inputBox' />            
            </Grid>
          <Grid item md={6} >
          <Typography component="label" sx={{ fontWeight: 600, fontFamily: 'Inter', fontSize:14 }}>Email</Typography>
           <input type="text" placeholder="Enter Your Email ID" className='inputBox' />            
            </Grid>
          <Grid item md={6} >
          <Typography component="label" sx={{ fontWeight: 600, fontFamily: 'Inter', fontSize:14 }}>Mobile Number</Typography>
           <input type="text" placeholder="Enter Your Mobile Number" className='inputBox' />            
            </Grid>
          <Grid item md={12} >
          <Typography component="label" sx={{ fontWeight: 600, fontFamily: 'Inter', fontSize:14 }}>Tell Us About Yourself</Typography>
          <textarea className='inputBox' style={{resize:'none',height:'200px', width:'100%'}}  placeholder="Write Something Here.."></textarea>          
            <FormControlLabel control={<Checkbox />} label="Agree With Terms & Conditions" />
            </Grid>
        
            </Grid>
            <Box className="flexbgbtnsend" >
              <button className="bgbtn" type="button" alignItems={'start'}>
              Send Message <ArrowForwardIos sx={{ fontSize: "16px" }} />{" "}
              </button>              
            </Box>
             </form>
          </Grid>
        </Grid>
      </Box>
    </>
  )
}
